import { IFormErrors } from '@interfaces/IFormsErrors';

export interface IESDPChangesState {
  isLoading: boolean;
  success: boolean;
  errors: IFormErrors | null;
  createTeamsErrors: IFormErrors[] | [];
}

export const initialESDPChangesState: IESDPChangesState = {
  isLoading: false,
  success: false,
  errors: null,
  createTeamsErrors: [],
};
